import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { SharedService } from '../../shared';
import { CannabisQuestion, THC_CBD_Group, ICDCodeMappings, THC_CBD_CardList, PartnerNamesEnum } from '../shared';

@Component({
    selector: 'thc-cbd-group',
    templateUrl: "./thc-cbd-group.component.html",
    styleUrls: ["./thc-cbd-group.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class THCCBDGroupComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() secOneQuestOne: CannabisQuestion;
    @Input() selectedGroup: THC_CBD_Group;
    @Input() recommendedTexts: any[] = [];
    @Output() onSelectGroup = new EventEmitter<any>();

    PartnerNamesEnum = PartnerNamesEnum;

    get secOneQuestOne_One() {
        return this.secOneQuestOne.questions.find(a => a.questionNumber === 1);
    }

    get secOneQuestOne_Two() {
        return this.secOneQuestOne.questions.find(a => a.questionNumber === 2);
    }

    get secOneQuestOne_Three() {
        return this.secOneQuestOne.questions.find(a => a.questionNumber === 3);
    }

    get IsVisibleForPartner() {
        switch (this.partnerName) {
            case PartnerNamesEnum.FOUR_20_PHARMA:
                return false;
            default:
                return true;
        }
    }

    get showRecommendations() {
        if (this.secOneQuestOne) {
            const optionThree = this.secOneQuestOne_Three.answer.option;
            if (ICDCodeMappings.find(a => a.Code === optionThree.Code)) {
                return true;
            }
            const optionTwo = this.secOneQuestOne_Two.answer.option;
            if (ICDCodeMappings.find(a => a.Code === optionTwo.Code)) {
                return true;
            }
            const optionOne = this.secOneQuestOne_One.answer.option;
            if (ICDCodeMappings.find(a => a.Code === optionOne.Code)) {
                return true;
            }
        }
        return false;
    }

    get showLegend() {
        if (!this.recommendedTexts.length) {
            return false;
        }
        var isShow = false;
        for (var j = 0; j < THC_CBD_CardList.length; j++) {
            const group = THC_CBD_CardList[j];
            let MapTo = [];
            for (var i = 0; i < ICDCodeMappings.length; i++) {
                const icdMap = ICDCodeMappings[i];
                if (this.recommendedTexts.find(a => a.Code === icdMap.Code)) {
                    MapTo = icdMap.MapTo;
                }
            }
            isShow = MapTo.indexOf(group.No) > -1;
            if (isShow) {
                break;
            }
        }
        return isShow;
    }

    constructor(private sharedService: SharedService,
        private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    getRecommendation() {
        this.recommendedTexts = [];
        if (this.secOneQuestOne) {
            const optionThree = this.secOneQuestOne_Three.answer.option;
            const optionTwo = this.secOneQuestOne_Two.answer.option;
            const optionOne = this.secOneQuestOne_One.answer.option;
            if (ICDCodeMappings.find(a => a.Code === optionThree.Code)) {
                this.recommendedTexts.push({
                    Code: optionThree.Code,
                    Text: `${optionOne.Label} / ${optionTwo.Label} / ${optionThree.Label}`
                });
            } else if (ICDCodeMappings.find(a => a.Code === optionTwo.Code)) {
                this.recommendedTexts.push({
                    Code: optionTwo.Code,
                    Text: `${optionOne.Label} / ${optionTwo.Label}`
                });
            } else if (ICDCodeMappings.find(a => a.Code === optionOne.Code)) {
                this.recommendedTexts.push({
                    Code: optionOne.Code,
                    Text: `${optionOne.Label}`
                });
            }
        }
    }

    selectGroup(group: THC_CBD_Group) {
        this.onSelectGroup.emit(group);
    }

}
